import useCountriesQuery from 'queries/useCountriesQuery';
import { type FC, useMemo } from 'react';

import Select, { Props as SelectProps } from './Select';

interface Props extends SelectProps {}

const CountrySelect: FC<Props> = (props) => {
  const { data, loading } = useCountriesQuery();

  const countries = useMemo(() => {
    if (data?.countries == null) {
      return [];
    }

    return [...data.countries].sort((countryA, countryB) => {
      return Intl.Collator().compare(countryA.name, countryB.name);
    });
  }, [data]);

  return (
    <Select
      {...props}
      disabled={props.disabled || loading}
      value={props.value || ''}
      onChange={props.onChange}
    >
      <option />
      {countries.map((country) => (
        <option key={country.alpha3} value={country.alpha3}>
          {country.name}
        </option>
      ))}
    </Select>
  );
};

export default CountrySelect;
